/* global axios */
import ApiClient from './ApiClient';

class DealReportsAPI extends ApiClient {
  constructor() {
    super('deal_reports', { accountScoped: true });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getByStage(params = {}) {
    return axios.get(`${this.url}/by_stage`, { params });
  }

  getByAgent(params = {}) {
    return axios.get(`${this.url}/by_agent`, { params });
  }

  getLossReasons(params = {}) {
    return axios.get(`${this.url}/loss_reasons`, { params });
  }

  getTimeline(params = {}) {
    return axios.get(`${this.url}/timeline`, { params });
  }

  getConversionFunnel(params = {}) {
    return axios.get(`${this.url}/conversion_funnel`, { params });
  }

  // Pipeline Metrics - Phase 5
  getForecast(params = {}) {
    return axios.get(`${this.url}/forecast`, { params });
  }

  getVelocity(params = {}) {
    return axios.get(`${this.url}/velocity`, { params });
  }

  getAging(params = {}) {
    return axios.get(`${this.url}/aging`, { params });
  }

  getGoals(params = {}) {
    return axios.get(`${this.url}/goals`, { params });
  }

  getDetails(params = {}) {
    return axios.get(`${this.url}/details`, { params });
  }

  getOperations(params = {}) {
    return axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/operational_report`,
      { params }
    );
  }

  // Helper to get all report data at once
  async getAllReports(params = {}) {
    const [summary, byStage, byAgent, lossReasons, timeline] =
      await Promise.all([
        this.getSummary(params),
        this.getByStage(params),
        this.getByAgent(params),
        this.getLossReasons(params),
        this.getTimeline(params),
      ]);

    return {
      summary: summary.data,
      byStage: byStage.data,
      byAgent: byAgent.data,
      lossReasons: lossReasons.data,
      timeline: timeline.data,
    };
  }
}

export default new DealReportsAPI();
